import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { FaxHooks, FaxV1 } from '@frontend/api-fax';
import { useWebsocketEventSubscription } from '@frontend/websocket';

export const useFaxReadEventSubscription = () => {
  const { updateFaxInListFaxCache, invalidateListBlockedFaxes, invalidateListArchivedFaxes } =
    FaxV1.FaxQueryUpdaters.useListFaxQueryUpdater();
  const invalidateFaxCount = FaxHooks.useInvalidateFaxCount();

  return useWebsocketEventSubscription(NotificationType.FAX_READ_STATUS_CHANGE, (payload) => {
    invalidateFaxCount();
    invalidateListBlockedFaxes();
    invalidateListArchivedFaxes();
    updateFaxInListFaxCache({ faxId: payload.params.faxId, locationId: payload.params.locationId });
  });
};
